import cn from "classnames";
import { FC } from "react";
import styles from "./Table.module.scss";
import { getScreenSize } from "@utils/getScreenSize";
import { shortWallet } from "@utils/shortWallet";

interface Props {
    link: string;
    date: string;
    status: "Verified" | "SCAM" | "Suspiciously" | "Review";
    name: string;
    walletNumber: string;
}

const TableRow: FC<Props> = ({ status, link, date, name, walletNumber }) => {
    const { isMobile } = getScreenSize();
    return (
        <>
            {!isMobile ? (
                <tr>
                    <td>{name}</td>
                    <td>{date} </td>
                    <td>{shortWallet(walletNumber)}</td>
                    <td>
                        {status !== "Review" && (
                            <a href={link} className={styles.view}>
                                <span>View</span>
                                <img width={14} height={14} src="/images/scam/arrow.svg" alt="" />
                            </a>
                        )}
                    </td>
                    <td className={styles.statusHolder}>
                        <span className={cn(styles.status, styles[status])}>{status}</span>
                    </td>
                </tr>
            ) : (
                <div className={styles.mobileRow}>
                    <div className={styles.mobileRowTop}>
                        <div className={styles.mobileRowTransaction}>{name}</div>
                        <div className={styles.mobileRowDate}>
                            <span>{date}</span>
                            <span className={cn(styles.status, styles[status])}>{status}</span>
                        </div>
                    </div>
                    <span className={styles.separator} />
                    <div className={styles.mobileRowBottom}>
                        <div className={styles.mobileRowLeft}>{shortWallet(walletNumber)}</div>
                        <div className={styles.mobileRowLink}>
                            <a href={link}>
                                <span>View</span>
                                <img width={14} height={14} src="/images/scam/arrow.svg" alt="" />
                            </a>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default TableRow;
